import React, { useEffect } from 'react';
import hotkeys from '@uber/hotkeys';
import { styled } from 'baseui';
import { type RGBColor } from '../../constants/colors';
const Container = styled<'div', {
  $selected: boolean;
}>('div', ({
  $theme,
  $selected
}) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  backgroundColor: $selected ? $theme.colors.buttonTertiaryHover : undefined,
  paddingTop: '16px',
  paddingBottom: '16px',
  paddingRight: '10px',
  paddingLeft: '25px',
  borderBottom: `1px solid ${$theme.borders.border300.borderColor}`,
  cursor: 'pointer',
  boxSizing: 'border-box',
  ...($selected ? {
    border: `1px solid ${$theme.colors.primaryA}`
  } : {}),
  ':hover': {
    backgroundColor: $theme.colors.buttonTertiaryHover
  }
}));
const IntentName = styled<'span', {
  $color: RGBColor;
}>('span', ({
  $color
}) => {
  const color = `rgb(${$color.join(',')})`;
  return {
    color,
    textTransform: 'capitalize',
    position: 'relative',
    paddingLeft: '20px',
    '::before': {
      content: '""',
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      backgroundColor: color,
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)'
    }
  };
});
const Hotkey = styled<'span', {
  $color: RGBColor;
}>('span', ({
  $color
}) => {
  const color = `rgb(${$color.join(',')})`;
  return {
    display: 'flex',
    marginLeft: '12px',
    border: `1px solid ${color}`,
    color,
    padding: '0px 4px',
    borderRadius: '2px',
    backgroundColor: `rgba(${$color.join(',')}, 0.2)`
  };
});
export type IntentT = {
  value: string;
  color: RGBColor;
  hotkey?: string | null;
};
type PropsT = {
  intent: IntentT;
  onIntentSelect: (intent: IntentT) => void;
  isSelected?: boolean;
};
const Intent = ({
  intent,
  onIntentSelect,
  isSelected
}: PropsT) => {
  const {
    value,
    color,
    hotkey
  } = intent;
  useEffect(() => {
    if (!hotkey) return;
    const owner = {
      name: hotkey
    };
    const hotkeyData = {
      name: hotkey,
      group: 'Intent',
      callback: () => onIntentSelect(intent)
    };
    hotkeys.register(owner, {
      [hotkey]: hotkeyData
    });
    return () => {
      hotkeys.unregister(owner);
    };
  }, [hotkey, onIntentSelect, intent]);
  return <Container $selected={!!isSelected} onClick={() => onIntentSelect(intent)}>
      <IntentName $color={color}>{value}</IntentName>
      {hotkey && <Hotkey $color={color}>{hotkey}</Hotkey>}
    </Container>;
};
export default Intent;